<script>
/**
 * This component renders a single svg icon to be displayed on the left
 * of the transaction item in the mobile transaction list.
 */
import IconIn from '@img/icons/lucide/arrow-down-left.svg?vue';
import IconOut from '@img/icons/lucide/arrow-up-right.svg?vue';
import IconExcesses from '@img/icons/lucide/undo-2.svg?vue';
import IconBurn from '@img/icons/lucide/flame.svg?vue';
import IconJettonMint from '@img/icons/lucide/sparkles.svg?vue';
import IconServiceAction from '@img/icons/lucide/refresh-cw.svg?vue';
import IconInternalTransfer from '@img/icons/lucide/route.svg?vue';
import IconNftIn from '@img/icons/lucide/image-down.svg?vue';
import IconNftOut from '@img/icons/lucide/image-up.svg?vue';
import IconNftPurchase from '@img/icons/lucide/shopping-bag.svg?vue';
import IconNftMint from '@img/icons/lucide/image-plus.svg?vue';
import IconConfirmation from '@img/icons/lucide/check.svg?vue';
import IconConfirmationDouble from '@img/icons/lucide/check-check.svg?vue';
import IconSwap from '@img/icons/lucide/arrow-left-right.svg?vue';
import IconContractDeploy from '@img/icons/lucide/square-dashed-bottom-code.svg?vue';
import IconSmartContractExec from '@img/icons/lucide/code.svg?vue';
import IconSmartContractExecV2 from '@img/icons/lucide/terminal.svg?vue';
import IconStake from '@img/icons/lucide/piggy-bank.svg?vue';
import IconStakeIn from '@img/icons/lucide/hand-coins.svg?vue';
import IconStakeOut from '@img/icons/lucide/landmark.svg?vue';
// import IconStakePush from '@img/icons/lucide/send.svg?vue';
import IconStakeDeposit from '@img/icons/lucide/layers-plus.svg?vue';
import IconEvaaSupply from '@img/icons/lucide/diamond-plus.svg?vue';
import IconContractCall from '@img/icons/lucide/square-code.svg?vue';
import IconStakeWithdraw from '@img/icons/lucide/layers-arrow-up.svg?vue';
import IconAuctionBid from '@img/icons/lucide/gavel.svg?vue';
import IconSubscribe from '@img/icons/lucide/bell-plus.svg?vue';
import IconUnsubscribe from '@img/icons/lucide/bell-off.svg?vue';
import IconMultisigCreateOrder from '@img/icons/lucide/list-plus.svg?vue';
import IconKeyRound from '@img/icons/lucide/key-round.svg?vue';
import IconUnknown from '@img/icons/lucide/squircle-dashed.svg?vue';

/* eslint-disable "quote-props" */
const tonapiEventToIconMap = Object.freeze({
    auction_bid: IconAuctionBid,
    contract_deploy: IconContractDeploy,
    call_contract: IconContractCall,
    deploy_nft: IconNftMint,
    deposit_stake: IconStakeDeposit,
    elections_deposit_stake: IconStakeOut,
    elections_recover_stake: IconStakeIn,
    jetton_mint: IconJettonMint,
    nft_purchase: IconNftPurchase,
    received_nft: IconNftIn,
    sent_nft: IconNftOut,
    smart_contract_exec: IconSmartContractExecV2,
    subscribe: IconSubscribe,
    unsubscribe: IconUnsubscribe,
    withdraw_stake: IconStakeWithdraw,
    withdraw_stake_request: IconStakeIn,
    dex_deposit_liquidity: IconStakeDeposit,
    dex_withdraw_liquidity: IconStakeWithdraw,
    multisig_execute: IconSmartContractExec,
    multisig_approve: IconConfirmation,
    multisig_create_order: IconMultisigCreateOrder,
    jvault_stake: IconStakeDeposit,
    jvault_unstake_request: IconStakeIn,
    jvault_unstake: IconStakeWithdraw,
    jvault_claim: IconStakeIn,
    vesting_add_whitelist: IconServiceAction,
    vesting_send_message: IconSmartContractExec,
    evaa_supply: IconEvaaSupply,
    evaa_withdraw: IconStakeWithdraw,
    evaa_liquidate: IconSmartContractExec,
    gasless_request: IconStakeIn,
    change_wallet_key: IconKeyRound,
    teleitem_start_auction: IconAuctionBid,
    teleitem_cancel_auction: IconAuctionBid,
    unknown: IconUnknown,
});

const tonscanActionToIconMap = Object.freeze({
    'jetton:burn': IconBurn,
    'jetton:burn_notification': IconBurn,
    'jetton:excesses': IconExcesses,
    'jetton:internal_transfer': IconInternalTransfer,
    'jetton:swap': IconSwap,
    'jetton:transfer': IconOut,
    'jetton:transfer_notification': IconIn,
    'nft:excesses': IconExcesses,
    'nft:ownership_assigned': IconNftIn,
    'nft:transfer': IconNftOut,
    'pool:new_stake': IconServiceAction,
    'pool:new_stake_ok': IconConfirmation,
    'pool:process_withdraw_requests': IconServiceAction,
    'pool:recover_stake': IconStake,
    'pool:recover_stake_ok': IconConfirmationDouble,
    'pool:update_validator_set_hash': IconServiceAction,
});

export default {
    render(h) {
        return h(this.getIcon());
    },

    props: {
        actionName: String,
        eventName: String,
        amount: String,
        isOut: Boolean,
    },

    methods: {
        getIcon() {
            let icon = this.eventName in tonapiEventToIconMap
                ? tonapiEventToIconMap[this.eventName]
                : tonscanActionToIconMap[this.actionName];

            // Special case: large amounts and new_stake actions probably means adding new stake:
            if (this.actionName === 'pool:new_stake' && this.amount > 5000000000) {
                icon = IconStake;
            }

            return icon ?? (this.isOut ? IconOut : IconIn);
        },
    },
};
</script>
